import ability from './ability'
import utils from '@/auth/utils'
import { SAVE_REQUIRED_SERVICE } from '@/store/common/mutation-type'
import store from '@/store'
import { auth } from '@/auth/hyper-auth'
import { REGULLAR_BILLING, CREDIT_CARD_USER } from '@/service'

export const canService = to => to.matched.some(route => {
    return route.meta.services.some(service => {
        return ability.can('READ', service) || ability.can('WRITE', service)
    })
})

export const ifNotAuthenticated = async (to, from, next) => {
    const isLoggedIn = await utils.isUserLoggedIn()

    if (isLoggedIn) {
        next(utils.getRouteForLoggedInUser())
    } else {
        next()
    }
}

export const ifAuthenticated = async (to, from, next) => {
    try {
        const isLoggedIn = await utils.isUserLoggedIn()
        if (utils.isTcPopsLogin()) {
            const AGGREEMENT_PAGE_NAME = 'agreement'
            if (to.name !== AGGREEMENT_PAGE_NAME) {
                return next({ name: AGGREEMENT_PAGE_NAME })
            } else {
                return next()
            }
        }

        // Redirect to login if not logged in
        if (!isLoggedIn) {
            const LOGIN_PAGE_NAME = 'auth-login'
            if (from.name !== LOGIN_PAGE_NAME) {
                localStorage.removeItem(auth.authConfig.storageTokenKeyName)
                return next({ name: LOGIN_PAGE_NAME })
            }
            return
        }

        // Get Region
        await store.dispatch('getRegions')
        // Update ability
        const data = utils.createAbility()
        if (data) {
            ability.update(data)
        }
        // ** Billing Only **
        const haveBillingData = await utils.isUserMonths(to)
        const withoutService = utils.withoutServicePage(to)
        if (!haveBillingData && withoutService) {
            return next()
        }

        // required service
        if (canService(to)) {
            const services = to.meta.services
            services.forEach(serviceName => {
                const utilUserService = utils.getUserService(serviceName)
                if ([REGULLAR_BILLING, CREDIT_CARD_USER].includes(serviceName)) {
                    store.commit(SAVE_REQUIRED_SERVICE, utilUserService.serviceIdx)
                    return next()
                } else if (haveBillingData) {
                    store.commit(SAVE_REQUIRED_SERVICE, utilUserService.serviceIdx)
                    return next()
                } else {
                    const DEFAULT_PAGE_NAME = 'infomation'
                    return next({ name: DEFAULT_PAGE_NAME })
                }
            })
        }
    } catch (error) {
        if (process.env.VUE_APP_ENV === 'development') {
            alert('Wait please...')
        }
        throw error
    }
}
export const fromAuthCenter = async (to, from, next) => {
    const path = await utils.getRouteForUserFromAuthCenter(to.params)
    return next(path)
}

export const fromAdmin = async (to, from, next) => {
    const path = await utils.getRouteForUserFromAdmin(to.params)
    return next(path)
}

export const _ = undefined
